import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { STORES_APP_DEF_ID } from '@wix/wixstores-client-core/dist/src/constants';
const USE_GET_CLIENT_CONFIG_FROM_PUBLIC_API = 'specs.stores.UseGetClientConfigFromPublicApi';
export class ViewerContext {
  constructor(siteStore, experiments, wixCodeApi) {
    this.siteStore = siteStore;
    this.experiments = experiments;
    this.wixCodeApi = wixCodeApi;
    _defineProperty(this, "_locale", void 0);
    _defineProperty(this, "_currency", void 0);
    _defineProperty(this, "_layoutDirection", void 0);
    _defineProperty(this, "_premiumFeatures", void 0);
    _defineProperty(this, "_taxName", void 0);
    _defineProperty(this, "_priceSettings", void 0);
  }
  get locale() {
    return this._locale;
  }
  get currency() {
    return this._currency;
  }
  get layoutDirection() {
    return this._layoutDirection;
  }
  get premiumFeatures() {
    return this._premiumFeatures;
  }
  get taxName() {
    return this._taxName;
  }
  get priceSettings() {
    return this._priceSettings;
  }
  getCurrentCurrency() {
    return this.siteStore.getCurrencyHeader() || this._currency;
  }
  async loadConfig() {
    if (this.experiments.enabled(USE_GET_CLIENT_CONFIG_FROM_PUBLIC_API)) {
      const publicApi = await this.wixCodeApi.site.getPublicAPI(STORES_APP_DEF_ID);
      const settings = await publicApi.settings.getOnlineStoresSettings();
      this._locale = settings.locale;
      this._currency = settings.storeCurrency;
      this._layoutDirection = settings.layoutDirection;
      this._premiumFeatures = settings.premiumFeatures;
      this._taxName = settings.taxName;
      this._priceSettings = settings.priceSettings;
    } else {
      await this.siteStore.loadClientConfig();
      this._locale = this.siteStore.locale;
      this._currency = this.siteStore.currency;
      this._layoutDirection = this.siteStore.layoutDirection;
      this._premiumFeatures = this.siteStore.premiumFeatures;
      this._taxName = this.siteStore.taxName;
      this._priceSettings = this.siteStore.priceSettings;
    }
  }
}
//# sourceMappingURL=ViewerContext.js.map